import { Directive, HostBinding, Input } from '@angular/core';
import { ColorsConstant } from '@shared/constants';

@Directive({
    selector: '[appProgressBarColor]'
})

export class ProgressBarColorDirective {
    @HostBinding('style.--mdc-linear-progress-active-indicator-color')
    @Input() appProgressBarColor: ColorsConstant = '';
}